module.exports = __webpack_public_path__ + "img/9-7-2022_estrellas.7517e68a.jpg";